import axios from 'axios';
import { ACCESS_TYPE, VENDING_URL } from '../atoms/const';

interface AddContactData {
    firstname:string;
    lastname:string;
    position:string;
    phoneNumber:string;
    email:string;
}

interface UpdateContactData {
    id: number;
    firstname:string;
    lastname:string;
    position:string;
    phoneNumber:string;
    email:string;
}

const add = (data: AddContactData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}add-new-contact`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

const update = (data: UpdateContactData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}update-contact`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

const contacts = {
  add, update,
};

export default contacts;
